import { useEffect } from "react";
import companyLogo from "../../assets/img/hl-logo-white.png";
import companyLogoWebp from "../../assets/img/hl-logo-white.webp";

const TopNavBar = () => {

    useEffect(() => {
        const script = document.createElement("script");
        script.textContent = `
            document.addEventListener("click", function (event) {
            const navbar = document.getElementById("topNavbarNav");

            if (navbar && navbar.classList.contains("show")) {
                const bsNavbar = new bootstrap.Collapse(navbar);
                bsNavbar.hide();
            }
            });
        `;
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <section id="top-nav-bar" className="gg-bg-gradient-h">
            <div className="container-fluid py-2 text-white">
                <div className="row align-items-center">
                    <div className="col-4 text-center">
                        <picture>
                            <source srcSet={companyLogoWebp} type="image/webp" />
                            <img className="img-fluid gg-logo-top-nav-bar" src={companyLogo} loading="lazy" />
                        </picture>                        
                    </div>
                    <div className="col-5 offset-3 gg-top-nav-bar-items-expanded d-flex justify-content-center align-items-center text-center">
                        <nav className="navbar navbar-expand-lg navbar-dark ms-5">
                            <button
                                id="topNavbarToggler"
                                className="navbar-toggler ms-1"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#topNavbarNav"
                                aria-controls="topNavbarNav"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                            >
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="topNavbarNav">
                                <ul className="navbar-nav">
                                    <li className="nav-item">
                                        <a href="#benefits" className="nav-link text-white gtm-nav-btn" data-gtm-label="GlucoGen - Top Nav Bar - Go to Benefits">Benefits</a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#ingredients" className="nav-link text-white gtm-nav-btn" data-gtm-label="GlucoGen - Top Nav Bar - Go to Ingredients">Ingredients</a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#countdown" className="nav-link text-white gtm-nav-btn" data-gtm-label="GlucoGen - Top Nav Bar - Go to Buy">Order Now</a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/info/contact" target="_blank" rel="noopener noreferrer" className="nav-link text-white gtm-nav-btn" data-gtm-label="GlucoGen - Top Nav Bar - Go to Support">Contact</a>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TopNavBar;